export const CONSTANTS = {
  USER_QUESTION_CHARACTER_LIMIT: 250,
  API_ENDPOINT: 'filteredRefinements',
  REFINEMENTS_THRESHOLD: 9,
  MIN_KEY_STROKES_LENGTH: 2
};
